import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { ICreateAbsenceRequestDTO, IEmployeeBalanceDTO } from 'src/api/dtos';
import { AbsenceBalanceBreakdown, AbsenceBalanceSummary } from 'src/features/absences/future-balance';
import { ComponentWithFade } from 'src/shared/hocs';
import { useTranslate } from 'src/shared/providers';
import { RootState } from 'src/store/types';

interface Props {
  inputs: Partial<ICreateAbsenceRequestDTO>;
  balance: IEmployeeBalanceDTO | undefined;
}

export const AbsenceBalanceRequest: FC<Props> = ({ balance, inputs }) => {
  const { t } = useTranslate();
  const { settings } = useSelector((state: RootState) => state.user);

  if (!balance) {
    return null;
  }

  return (
    <ComponentWithFade show mountDuration={200}>
      <div className="mb-3">
        <p className="mb-3 fw-500">{t('absences.balancesSummary')}</p>
        <AbsenceBalanceSummary
          balance={balance}
          shouldShowError={!!settings?.isFutureBalanceViolationBlockEnabled}
          shouldDisplayAsDays={!!settings?.showAccrualBalanceInDays}
          isFutureBalanceCheckEnabled={!!settings?.isFutureBalanceCheckEnabled}
        />
      </div>
      <div>
        <p className="mb-3 fw-500 me-2">{t('absences.balancesBreakdown')}</p>
        <AbsenceBalanceBreakdown
          startDate={inputs.startDate as string}
          endDate={inputs.endDate as string}
          startTime={inputs.startTime}
          endTime={inputs.endTime}
          transactions={balance.employeeBalancesTrans}
          status={balance.status}
        />
      </div>
    </ComponentWithFade>
  );
};
